import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContentPath } from './content-path';

export interface ContentHeaderState {
  title: string;
  subtitle: string;
  showContentHeader: boolean;
  loading: boolean;
  contentsPath: ContentPath[];
  contentId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContentHeaderService {
  private readonly defaultState: ContentHeaderState = {
    title: 'Dashboard',
    subtitle: '',
    showContentHeader: false,
    loading: false,
    contentsPath: [],
    contentId: '',
  };

  private state$ = new BehaviorSubject<ContentHeaderState>(this.defaultState);

  getState(): Observable<ContentHeaderState> {
    return this.state$.asObservable();
  }

  getCurrentState(): ContentHeaderState {
    return this.state$.getValue();
  }

  updateState(partial: Partial<ContentHeaderState>): void {
    this.state$.next({
      ...this.state$.getValue(),
      ...partial,
    });
  }

  setTitle(title: string): void {
    this.updateState({ title });
  }

  setSubtitle(subtitle: string): void {
    this.updateState({ subtitle });
  }

  setShowContentHeader(show: boolean): void {
    this.updateState({ showContentHeader: show });
  }

  setLoading(loading: boolean): void {
    this.updateState({ loading });
  }

  reset(): void {
    this.state$.next(this.defaultState);
  }
}
